export  const words = {
    A: {
        character: 'A',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 4, 1, 1, 5, 0, 1, 0, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    B: {
        character: 'B',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 1, 1, 5, 0, 1, 0, 0, 1, 0, 1, 1, 1, 7, 0, 1, 0, 0, 1, 0, 1, 1, 1, 2, 0, 0, 0, 0, 0]
    },
    C: {
        character: 'C',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 4, 1, 1, 5, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 3, 1, 1, 2, 0, 0, 0, 0, 0]
    },
    D: {
        character: 'D',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 1, 1, 5, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 1, 2, 0, 0, 0, 0, 0]
    },
    E: {
        character: 'E',
        width: 4,
        coordinates: [0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0]
    },
    F: {
        character: 'F',
        width: 4,
        coordinates: [0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0]
    },
    G: {
        character: 'G',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 4, 1, 1, 5, 0, 1, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 3, 1, 1, 2, 0, 0, 0, 0, 0]
    },
    H: {
        character: 'H',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    I: {
        character: 'I',
        width: 4,
        coordinates: [0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 0, 0]
    },
    J: {
        character: 'J',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 0, 0, 4, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 0, 1, 0, 3, 1, 1, 2, 0, 0, 0, 0, 0]
    },
    K: {
        character: 'K',
        width: 4,
        coordinates: [0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 4, 2, 0, 1, 1, 0, 0, 1, 3, 5, 0, 1, 0, 1, 0, 0, 0, 0]
    },
    L: {
        character: 'L',
        width: 4,
        coordinates: [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0]
    },
    M: {
        character: 'M',
        width: 6,
        coordinates: [0, 0, 0, 0, 0, 0, 0, 1, 5, 0, 4, 1, 0, 1, 3, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    N: {
        character: 'N',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 5, 0, 1, 0, 1, 3, 5, 1, 0, 1, 0, 3, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    O: {
        character: 'O',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 4, 1, 1, 5, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 3, 1, 1, 2, 0, 0, 0, 0, 0]
    },
    P: {
        character: 'P',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 1, 1, 5, 0, 1, 0, 0, 1, 0, 1, 1, 1, 2, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    Q: {
        character: 'Q',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 4, 1, 1, 5, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 6, 1, 0, 3, 1, 1, 7, 0, 0, 0, 0, 0]
    },
    R: {
        character: 'R',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 1, 1, 5, 0, 1, 0, 0, 1, 0, 1, 1, 1, 2, 0, 1, 0, 3, 5, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    S: {
        character: 'S',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 4, 1, 1, 5, 0, 1, 0, 0, 0, 0, 3, 1, 1, 5, 0, 0, 0, 0, 1, 0, 3, 1, 1, 2, 0, 0, 0, 0, 0]
    },
    T: {
        character: 'T',
        width: 6,
        coordinates: [0, 0, 0, 0, 0, 0,
                      0, 1, 1, 1, 1, 1, 
                      0, 0, 0, 1, 0, 0, 
                      0, 0, 0, 1, 0, 0, 
                      0, 0, 0, 1, 0, 0,
                      0, 0, 0, 1, 0, 0,
                      0, 0, 0, 0, 0, 0]
    },
    U: {
        character: 'U',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 3, 1, 1, 2, 0, 0, 0, 0, 0]
    },
    V: {
        character: 'V',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 3, 5, 4, 2, 0, 0, 3, 2, 0, 0, 0, 0, 0, 0]
    },
    W: {
        character: 'W',
        width: 6,
        coordinates: [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 4, 1, 5, 1, 0, 3, 2, 0, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    X: {
        character: 'X',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 3, 5, 4, 2, 0, 0, 9, 7, 0, 0, 4, 2, 3, 5, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    Y: {
        character: 'Y',
        width: 6,
        coordinates: [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 3, 5, 0, 4, 2, 0, 0, 3, 1, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    Z: {
        character: 'Z',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 4, 2, 0, 0, 4, 2, 0, 0, 4, 2, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0]
    },
    ' ': {
        character: ' ',
        width: 2,
        coordinates: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    '!': {
        character: '!',
        width: 2,
        coordinates: [0, 0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0]
    },
    ',': {
        character: ',',
        width: 3,
        coordinates: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 2]
    },
    '?': {
        character: '?',
        width: 4,
        coordinates: [0,0,0,0, 0, 4, 1, 5, 0, 1, 0, 1, 0, 0, 4, 2, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    ".": {
        character: '.',
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    "\n": {
        character: "\n",
        width: 1,
        coordinates: []
    },
    0: {
        character: 0,
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 
                      0, 4, 1, 1, 5, 
                      0, 1, 0, 0, 1, 
                      0, 1, 0, 0, 1, 
                      0, 1, 0, 0, 1, 
                      0, 3, 1, 1, 2, 
                      0, 0, 0, 0, 0]
    },
    1: {
        character: 1,
        width: 2,
        coordinates: [0, 0, 
                      0, 1, 
                      0, 1, 
                      0, 1, 
                      0, 1, 
                      0, 1, 
                      0, 0]
    },
    2: {
        character: 2,
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 
                      0, 4, 1, 1, 5, 
                      0, 0, 0, 0, 1, 
                      0, 4, 1, 1, 2, 
                      0, 1, 0, 0, 0, 
                      0, 1, 1, 1, 1,
                      0, 0, 0, 0, 0]
    },
    3: {
        character: 3,
        width: 5,
        coordinates: [0, 0, 0, 0, 0,
                      0, 4, 1, 1, 5, 
                      0, 0, 0, 0, 1, 
                      0, 0, 1, 1, 7, 
                      0, 0, 0, 0, 1, 
                      0, 3, 1, 1, 2, 
                      0, 0, 0, 0, 0]
    },
    4: {
        character: 4,
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 
                      0, 0, 0, 4, 1, 
                      0, 0, 4, 2, 1,  
                      0, 4, 2, 0, 1, 
                      0, 1, 1, 1, 1, 
                      0, 0, 0, 0, 1, 
                      0, 0, 0, 0, 0]
    },
    5: {
        character: 5,
        width: 5,
        coordinates: [0, 0, 0, 0, 0,
                      0, 1, 1, 1, 1, 
                      0, 1, 0, 0, 0,
                      0, 1, 1, 1, 5, 
                      0, 0, 0, 0, 1, 
                      0, 3, 1, 1, 2, 
                      0, 0, 0, 0, 0]
    },
    6: {
        character: 6,
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 
                      0, 4, 1, 1, 5, 
                      0, 1, 0, 0, 0, 
                      0, 1, 1, 1, 5, 
                      0, 1, 0, 0, 1, 
                      0, 3, 1, 1, 2, 
                      0, 0, 0, 0, 0]
    },
    7: {
        character: 7,
        width: 5,
        coordinates: [0, 0, 0, 0, 0,
                      0, 1, 1, 1, 1,
                      0, 0, 0, 4, 2, 
                      0, 0, 4, 2, 0, 
                      0, 0, 1, 0, 0, 
                      0, 0, 1, 0, 0, 
                      0, 0, 0, 0, 0]
    },
    8: {
        character: 8,
        width: 5,
        coordinates: [0, 0, 0, 0, 0, 
                      0, 4, 1, 1, 5, 
                      0, 1, 0, 0, 1, 
                      0, 9, 1, 1, 7, 
                      0, 1, 0, 0, 1, 
                      0, 3, 1, 1, 2, 
                      0, 0, 0, 0, 0]
    },
    9: {
        character: 9,
        width: 5,
        coordinates: [0, 0, 0, 0, 0,
                      0, 4, 1, 1, 5, 
                      0, 1, 0, 0, 1, 
                      0, 3, 1, 1, 1,  
                      0, 0, 0, 0, 1, 
                      0, 3, 1, 1, 2, 
                      0, 0, 0, 0, 0]
    },
    '\u2764': {
        character: '❤️',
        width: 7,
        coordinates: [0, 0, 0, 0, 0, 0, 0,  
                      0, 4, 1, 5, 4, 1, 5, 
                      0, 1, 1, 1, 1, 1, 1, 
                      0, 3, 1, 1, 1, 1, 2, 
                      0, 0, 3, 1, 1, 2, 0, 
                      0, 0, 0, 3, 2, 0, 0,
                      0, 0, 0, 0, 0, 0, 0]
    }
}

export const getMaxLength = (tileWords) => {
    const lengths = [];
    let currentLenth = 0;    

    for (let i = 0; i < tileWords?.length ; i++){
        
        if(tileWords?.[i] != "\n" && i != tileWords?.length - 1){
            currentLenth = currentLenth + words?.[tileWords?.[i].toUpperCase()]?.width;
        }
        else if(tileWords?.[i] != "\n" && i === tileWords?.length - 1){
            lengths?.push(currentLenth + 1 + words?.[tileWords?.[i].toUpperCase()]?.width);
            currentLenth = 0;
        } 
        else {
            lengths?.push(currentLenth+1);
            currentLenth = 0;
        }
    }    
    return Math.max(...lengths);
}

export const getCurrentLength = (tileWords, index) => {
    const lengths = [];
    let currentLenth = 0;    

    for (let i = 0; i < tileWords?.length ; i++){
        
        if(tileWords?.[i] != "\n" && i != tileWords?.length - 1){
            currentLenth = currentLenth + words?.[tileWords?.[i].toUpperCase()]?.width;
        }
        else if(tileWords?.[i] != "\n" && i === tileWords?.length - 1){
            if(index === i+1){
                lengths?.push(currentLenth + 1 + words?.[tileWords?.[i].toUpperCase()]?.width);       
                         
                return lengths?.[lengths?.length -1];
            }
            lengths?.push(currentLenth+1);
            currentLenth = 0;
        } 
        else {
            if(index === i){
                lengths?.push(currentLenth+1);

                return lengths?.[lengths?.length -1];
            }
            lengths?.push(currentLenth+1);
            currentLenth = 0;
        }
    }
    return lengths?.[lengths?.length -1];
}

export const getNLengthArray = (length) => {
    let preview = [];
    for (let i = 0; i < (length); i++) {
      preview.push(0);
    }    
    return preview;
}